import { Box } from "@chakra-ui/react";
import { FC } from "react";

const UnreadBadge: FC<{ count: number }> = ({ count }) => {
  return (
    <Box
      bgColor="primary.900"
      fontSize={count > 99 ? "9px" : "10px"}
      display="flex"
      flexDir="column"
      alignItems="center"
      justifyContent="center"
      w="22px"
      h="22px"
      borderRadius="11px"
      color="white"
    >
      {count > 99 ? "99+" : count}
    </Box>
  );
};

export default UnreadBadge;
